import React from 'react';
import NoteList from '../../../../shared/Notes/NotesList';
import { useNotesTabNavigation } from '../../../../../utils/appNavigationNames';

export type NotesRootScreenOwnProps = {};

export type NotesRootScreenProps = NotesRootScreenOwnProps;

const NotesRootScreen: React.FC<NotesRootScreenProps> = () => {
    const navigator = useNotesTabNavigation();

    return (
        <NoteList
            noteQueryArgs={{ entityType: 'user' }}
            onAddNote={(args) => {
                navigator.navigate('add', args);
            }}
            onViewDetails={(note) => {
                navigator.navigate('details', { noteId: note.noteId });
            }}
        />
    );
};

export default React.memo(NotesRootScreen);
